// frontend-react/src/components/RuleManagement/RuleSetHeader.tsx
// 兩個 Modal 共用的規則集名稱列
import React, { useState } from 'react';
import { Button, Input, Tooltip } from 'antd';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

interface RuleSetHeaderProps {
  name: string;
  subtext?: React.ReactNode; // 例：「上傳者：xxx」
  editable?: boolean; // 是否顯示名稱旁的鉛筆（AI 生成流程用）
  onNameChange?: ((name: string) => void) | undefined;
}

const RuleSetHeader: React.FC<RuleSetHeaderProps> = ({
  name,
  subtext,
  editable = false,
  onNameChange,
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const startEdit = () => {
    setDraft(name);
    setEditing(true);
  };

  const confirmEdit = () => {
    const trimmed = draft.trim();
    if (trimmed) onNameChange?.(trimmed);
    setEditing(false);
  };

  const cancelEdit = () => setEditing(false);

  return (
    <div style={{ marginBottom: '4px' }}>
      {/* 名稱列 */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '16px',
          fontWeight: 600,
        }}
      >
        {editing ? (
          <>
            <Input
              value={draft}
              onChange={e => setDraft(e.target.value)}
              onPressEnter={confirmEdit}
              size='small'
              autoFocus
              style={{ fontSize: '15px', fontWeight: 600, maxWidth: 360 }}
            />
            <Tooltip title='確認'>
              <Button
                type='text'
                size='small'
                icon={<CheckOutlined style={{ color: '#1E88A8' }} />}
                style={{ padding: '0 4px', height: 'auto' }}
                onClick={confirmEdit}
              />
            </Tooltip>
            <Tooltip title='取消'>
              <Button
                type='text'
                size='small'
                icon={<CloseOutlined style={{ color: '#aaa' }} />}
                style={{ padding: '0 4px', height: 'auto' }}
                onClick={cancelEdit}
              />
            </Tooltip>
          </>
        ) : (
          <>
            <span>{name || '（未命名）'}</span>
            {editable && (
              <Tooltip title='編輯規則集名稱'>
                <Button
                  type='text'
                  size='small'
                  icon={<EditOutlined style={{ fontSize: '13px', color: '#bbb' }} />}
                  style={{ padding: '0 4px', height: 'auto' }}
                  onClick={startEdit}
                />
              </Tooltip>
            )}
          </>
        )}
      </div>

      {/* 副標題（上傳者等） */}
      {subtext && (
        <div style={{ fontSize: '13px', color: '#888', marginTop: '2px' }}>{subtext}</div>
      )}
    </div>
  );
};

export default RuleSetHeader;
